import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import Beach from '../../components/Cards/beach';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';
import instagram2 from './images/ocean-beach@fiferries.jpg';
// import BeachCard from '../../components/Cards/beach';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Ocean Beach'
      meta={[
        {
          name: 'description',
          content:
            'Ocean Beach is the largest community on Fire Island of the 7 communities that Fire Island Ferries services.',
        },
        {
          name: 'keywords',
          content:
            'Ocean Beach, Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach='Ocean Beach'>
        <h2>Communities</h2>
        <h1>Ocean Beach</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach('Ocean Beach').map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>

        <div>
          <Link className='btn btn-outline-light' to='/schedules/ocean-beach'>
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Ocean Beach</h1>
          </div>
          <p>
            The Incorporated Village of Ocean Beach is the largest community on
            Fire Island, with the most to offer visitors, renters, and
            residents. Ocean Beach’s Main Street has several full-service
            restaurants and bars, diverse gift shops and clothing stores, two
            pizza parlors and ice cream shops, a candy shop, and even a few
            hotels. The village also has a year-round police force and Post
            Office.
          </p>
          <Tip title="Captain's Tip">
            When visiting Ocean Beach please remember to respect the locals and
            the village ordinances, otherwise you may be conversing with OBPD.
          </Tip>
        </div>
        <div className='col-xl-4'>
          <Instagram
            account='fiferries'
            datestamp='July 2nd, 2015'
            profile={fiferries}
            image={instagram2}
            link='https://www.instagram.com/fiferries'
            className='mx-auto'
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-xl order-xl-12'>
          <p>
            The Fire Island wide elementary school, The Woodhull School, and the
            public library are also located within this sprawling 600+ home
            community.
          </p>
          <p>
            Away from the commercial district of Ocean Beach the town becomes a
            quiet refuge for families and group houses to forget the stresses of
            the main land, and enjoy the beach.
          </p>
          <p>
            Ocean Beach has several different cultural events throughout the
            summer to bring together the community for various worthy causes.
            Additionally, there are pay to play tennis and basketball courts
            located on the bayfront next to the ferry terminal, as well as a
            marina of transient boat slips. There is something for everyone in
            this Fire Island metropolis.
          </p>
        </div>
        {/* <div className="col-xl-4 order-xl-1">
          <Instagram account="fiferries" datestamp="July 2nd, 2015" profile={fiferries} image={instagram2} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Ocean Beach is available by Fire Island
        Ferries from Bay Shore.{' '}
        <Link to='/schedules/ocean-beach'>Click here for schedules.</Link>
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Ocean Beach during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
